module.exports = {
	"id": "com.agnibho.com.dietsurvey.data",
	"timestamp": 1488885258572,
	"version": 20170307.1,
	"rda": [
		{
			"subject": "infant_0m-6m",
			"energy": "500.00",
			"protein": "0.00",
			"iron": "0.00",
			"vitA": "0.00",
			"thiamine": "0.20",
			"riboflavin": "0.30",
			"vitC": "25.00"
		},
		{
			"subject": "infant_6m-9m",
			"energy": "670.00",
			"protein": "13.40",
			"iron": "5.00",
			"vitA": "2100.00",
			"thiamine": "0.30",
			"riboflavin": "0.40",
			"vitC": "25.00"
		},
		{
			"subject": "infant_9m-12m",
			"energy": "670.00",
			"protein": "14.90",
			"iron": "5.00",
			"vitA": "2100.00",
			"thiamine": "0.30",
			"riboflavin": "0.40",
			"vitC": "25.00"
		},
		{
			"subject": "male_1y",
			"energy": "1060.00",
			"protein": "15.10",
			"iron": "9.00",
			"vitA": "3200.00",
			"thiamine": "0.50",
			"riboflavin": "0.60",
			"vitC": "40.00"
		},
		{
			"subject": "male_2y",
			"energy": "1060.00",
			"protein": "16.00",
			"iron": "9.00",
			"vitA": "3200.00",
			"thiamine": "0.50",
			"riboflavin": "0.60",
			"vitC": "40.00"
		},
		{
			"subject": "male_3y",
			"energy": "1060.00",
			"protein": "17.20",
			"iron": "9.00",
			"vitA": "3200.00",
			"thiamine": "0.50",
			"riboflavin": "0.60",
			"vitC": "40.00"
		},
		{
			"subject": "male_4y",
			"energy": "1350.00",
			"protein": "18.30",
			"iron": "13.00",
			"vitA": "3200.00",
			"thiamine": "0.70",
			"riboflavin": "0.80",
			"vitC": "40.00"
		},
		{
			"subject": "male_5y",
			"energy": "1350.00",
			"protein": "19.80",
			"iron": "13.00",
			"vitA": "3200.00",
			"thiamine": "0.70",
			"riboflavin": "0.80",
			"vitC": "40.00"
		},
		{
			"subject": "male_6y",
			"energy": "1350.00",
			"protein": "23.50",
			"iron": "13.00",
			"vitA": "3200.00",
			"thiamine": "0.70",
			"riboflavin": "0.80",
			"vitC": "40.00"
		},
		{
			"subject": "male_7y",
			"energy": "1690.00",
			"protein": "26.60",
			"iron": "16.00",
			"vitA": "4800.00",
			"thiamine": "0.80",
			"riboflavin": "1.00",
			"vitC": "40.00"
		},
		{
			"subject": "male_8y",
			"energy": "1690.00",
			"protein": "29.70",
			"iron": "16.00",
			"vitA": "4800.00",
			"thiamine": "0.80",
			"riboflavin": "1.00",
			"vitC": "40.00"
		},
		{
			"subject": "male_9y",
			"energy": "1690.00",
			"protein": "33.00",
			"iron": "16.00",
			"vitA": "4800.00",
			"thiamine": "0.80",
			"riboflavin": "1.00",
			"vitC": "40.00"
		},
		{
			"subject": "male_10y",
			"energy": "2190.00",
			"protein": "36.30",
			"iron": "21.00",
			"vitA": "4800.00",
			"thiamine": "1.10",
			"riboflavin": "1.30",
			"vitC": "40.00"
		},
		{
			"subject": "male_11y",
			"energy": "2190.00",
			"protein": "39.60",
			"iron": "21.00",
			"vitA": "4800.00",
			"thiamine": "1.10",
			"riboflavin": "1.30",
			"vitC": "40.00"
		},
		{
			"subject": "male_12y",
			"energy": "2190.00",
			"protein": "43.70",
			"iron": "21.00",
			"vitA": "4800.00",
			"thiamine": "1.10",
			"riboflavin": "1.30",
			"vitC": "40.00"
		},
		{
			"subject": "male_13y",
			"energy": "2750.00",
			"protein": "49.80",
			"iron": "32.00",
			"vitA": "4800.00",
			"thiamine": "1.40",
			"riboflavin": "1.60",
			"vitC": "40.00"
		},
		{
			"subject": "male_14y",
			"energy": "2750.00",
			"protein": "54.70",
			"iron": "32.00",
			"vitA": "4800.00",
			"thiamine": "1.40",
			"riboflavin": "1.60",
			"vitC": "40.00"
		},
		{
			"subject": "male_15y",
			"energy": "2750.00",
			"protein": "58.20",
			"iron": "32.00",
			"vitA": "4800.00",
			"thiamine": "1.40",
			"riboflavin": "1.60",
			"vitC": "40.00"
		},
		{
			"subject": "male_16y",
			"energy": "3020.00",
			"protein": "60.80",
			"iron": "28.00",
			"vitA": "4800.00",
			"thiamine": "1.50",
			"riboflavin": "1.80",
			"vitC": "40.00"
		},
		{
			"subject": "male_17y",
			"energy": "3020.00",
			"protein": "62.20",
			"iron": "28.00",
			"vitA": "4800.00",
			"thiamine": "1.50",
			"riboflavin": "1.80",
			"vitC": "40.00"
		},
		{
			"subject": "female_1y",
			"energy": "1060.00",
			"protein": "14.10",
			"iron": "9.00",
			"vitA": "3200.00",
			"thiamine": "0.50",
			"riboflavin": "0.30",
			"vitC": "40.00"
		},
		{
			"subject": "female_2y",
			"energy": "1060.00",
			"protein": "15.10",
			"iron": "9.00",
			"vitA": "3200.00",
			"thiamine": "0.50",
			"riboflavin": "0.30",
			"vitC": "40.00"
		},
		{
			"subject": "female_3y",
			"energy": "1060.00",
			"protein": "16.80",
			"iron": "9.00",
			"vitA": "3200.00",
			"thiamine": "0.50",
			"riboflavin": "0.30",
			"vitC": "40.00"
		},
		{
			"subject": "female_4y",
			"energy": "1350.00",
			"protein": "17.80",
			"iron": "13.00",
			"vitA": "3200.00",
			"thiamine": "0.70",
			"riboflavin": "0.80",
			"vitC": "40.00"
		},
		{
			"subject": "female_5y",
			"energy": "1350.00",
			"protein": "19.30",
			"iron": "13.00",
			"vitA": "3200.00",
			"thiamine": "0.70",
			"riboflavin": "0.80",
			"vitC": "40.00"
		},
		{
			"subject": "female_6y",
			"energy": "1350.00",
			"protein": "23.00",
			"iron": "13.00",
			"vitA": "3200.00",
			"thiamine": "0.70",
			"riboflavin": "0.80",
			"vitC": "40.00"
		},
		{
			"subject": "female_7y",
			"energy": "1690.00",
			"protein": "26.10",
			"iron": "16.00",
			"vitA": "4800.00",
			"thiamine": "0.80",
			"riboflavin": "1.00",
			"vitC": "40.00"
		},
		{
			"subject": "female_8y",
			"energy": "1690.00",
			"protein": "29.50",
			"iron": "16.00",
			"vitA": "4800.00",
			"thiamine": "0.80",
			"riboflavin": "1.00",
			"vitC": "40.00"
		},
		{
			"subject": "female_9y",
			"energy": "1690.00",
			"protein": "32.60",
			"iron": "16.00",
			"vitA": "4800.00",
			"thiamine": "0.80",
			"riboflavin": "1.00",
			"vitC": "40.00"
		},
		{
			"subject": "female_10y",
			"energy": "2010.00",
			"protein": "36.80",
			"iron": "27.00",
			"vitA": "4800.00",
			"thiamine": "1.00",
			"riboflavin": "1.20",
			"vitC": "40.00"
		},
		{
			"subject": "female_11y",
			"energy": "2010.00",
			"protein": "40.00",
			"iron": "27.00",
			"vitA": "4800.00",
			"thiamine": "1.00",
			"riboflavin": "1.20",
			"vitC": "40.00"
		},
		{
			"subject": "female_12y",
			"energy": "2010.00",
			"protein": "44.50",
			"iron": "27.00",
			"vitA": "4800.00",
			"thiamine": "1.00",
			"riboflavin": "1.20",
			"vitC": "40.00"
		},
		{
			"subject": "female_13y",
			"energy": "2330.00",
			"protein": "49.00",
			"iron": "27.00",
			"vitA": "4800.00",
			"thiamine": "1.20",
			"riboflavin": "1.40",
			"vitC": "40.00"
		},
		{
			"subject": "female_14y",
			"energy": "2330.00",
			"protein": "52.80",
			"iron": "27.00",
			"vitA": "4800.00",
			"thiamine": "1.20",
			"riboflavin": "1.40",
			"vitC": "40.00"
		},
		{
			"subject": "female_15y",
			"energy": "2330.00",
			"protein": "53.80",
			"iron": "27.00",
			"vitA": "4800.00",
			"thiamine": "1.20",
			"riboflavin": "1.40",
			"vitC": "40.00"
		},
		{
			"subject": "female_16y",
			"energy": "2440.00",
			"protein": "54.90",
			"iron": "26.00",
			"vitA": "4800.00",
			"thiamine": "1.00",
			"riboflavin": "1.20",
			"vitC": "40.00"
		},
		{
			"subject": "female_17y",
			"energy": "2440.00",
			"protein": "56.00",
			"iron": "26.00",
			"vitA": "4800.00",
			"thiamine": "1.00",
			"riboflavin": "1.20",
			"vitC": "40.00"
		},
		{
			"subject": "male_sedentary",
			"energy": "2320.00",
			"protein": "60.00",
			"iron": "17.00",
			"vitA": "4800.00",
			"thiamine": "1.20",
			"riboflavin": "1.40",
			"vitC": "40.00"
		},
		{
			"subject": "male_moderate",
			"energy": "2730.00",
			"protein": "60.00",
			"iron": "17.00",
			"vitA": "4800.00",
			"thiamine": "1.40",
			"riboflavin": "1.60",
			"vitC": "40.00"
		},
		{
			"subject": "male_heavy",
			"energy": "3490.00",
			"protein": "60.00",
			"iron": "17.00",
			"vitA": "4800.00",
			"thiamine": "1.70",
			"riboflavin": "2.10",
			"vitC": "40.00"
		},
		{
			"subject": "female_sedentary",
			"energy": "1900.00",
			"protein": "55.00",
			"iron": "21.00",
			"vitA": "4800.00",
			"thiamine": "1.00",
			"riboflavin": "1.10",
			"vitC": "40.00"
		},
		{
			"subject": "female_moderate",
			"energy": "2230.00",
			"protein": "55.00",
			"iron": "21.00",
			"vitA": "4800.00",
			"thiamine": "1.10",
			"riboflavin": "1.30",
			"vitC": "40.00"
		},
		{
			"subject": "female_heavy",
			"energy": "2850.00",
			"protein": "55.00",
			"iron": "21.00",
			"vitA": "4800.00",
			"thiamine": "1.40",
			"riboflavin": "1.70",
			"vitC": "40.00"
		},
		{
			"subject": "pregnant",
			"energy": "350.00",
			"protein": "78.00",
			"iron": "35.00",
			"vitA": "6400.00",
			"thiamine": "0.20",
			"riboflavin": "0.30",
			"vitC": "60.00"
		},
		{
			"subject": "lactating_below6",
			"energy": "600.00",
			"protein": "74.00",
			"iron": "25.00",
			"vitA": "7600.00",
			"thiamine": "0.30",
			"riboflavin": "0.40",
			"vitC": "80.00"
		},
		{
			"subject": "lactating_above6",
			"energy": "520.00",
			"protein": "68.00",
			"iron": "21.00",
			"vitA": "7600.00",
			"thiamine": "0.20",
			"riboflavin": "0.30",
			"vitC": "80.00"
		}
	],
	"food": [
		{
			"name": "Rice",
			"food_group": "Cereals",
			"energy": "348.00",
			"protein": "6.40",
			"fat": "0.40",
			"iron": "1.00",
			"calcium": "9.00",
			"vitA": "0.00",
			"vitC": "0.00",
			"thiamine": "0.21",
			"riboflavin": "0.05"
		},
		{
			"name": "Wheat",
			"food_group": "Cereals",
			"energy": "341.00",
			"protein": "12.10",
			"fat": "1.70",
			"iron": "4.90",
			"calcium": "48.00",
			"vitA": "29.00",
			"vitC": "0.00",
			"thiamine": "0.49",
			"riboflavin": "0.17"
		},
		{
			"name": "Dal",
			"food_group": "Pulses",
			"energy": "348.00",
			"protein": "24.50",
			"fat": "1.20",
			"iron": "3.90",
			"calcium": "75.00",
			"vitA": "49.00",
			"vitC": "0.00",
			"thiamine": "0.47",
			"riboflavin": "0.21"
		},
		{
			"name": "Lentil",
			"food_group": "Pulses",
			"energy": "343.00",
			"protein": "25.10",
			"fat": "0.60",
			"iron": "7.60",
			"calcium": "69.00",
			"vitA": "270.00",
			"vitC": "0.00",
			"thiamine": "0.45",
			"riboflavin": "0.20"
		},
		{
			"name": "Soyabean",
			"food_group": "Pulses",
			"energy": "432.00",
			"protein": "43.20",
			"fat": "19.50",
			"iron": "10.40",
			"calcium": "240.00",
			"vitA": "426.00",
			"vitC": "0.00",
			"thiamine": "0.73",
			"riboflavin": "0.39"
		},
		{
			"name": "Ground Nut",
			"food_group": "Nuts & Oilseeds",
			"energy": "567.00",
			"protein": "25.30",
			"fat": "40.10",
			"iron": "2.50",
			"calcium": "90.00",
			"vitA": "37.00",
			"vitC": "0.00",
			"thiamine": "0.90",
			"riboflavin": "0.13"
		},
		{
			"name": "Amaranth",
			"food_group": "GLV",
			"energy": "45.00",
			"protein": "4.00",
			"fat": "0.50",
			"iron": "3.49",
			"calcium": "397.00",
			"vitA": "5520.00",
			"vitC": "99.00",
			"thiamine": "0.03",
			"riboflavin": "0.30"
		},
		{
			"name": "Cabbage",
			"food_group": "GLV",
			"energy": "27.00",
			"protein": "1.80",
			"fat": "0.10",
			"iron": "0.80",
			"calcium": "39.00",
			"vitA": "120.00",
			"vitC": "124.00",
			"thiamine": "0.06",
			"riboflavin": "0.09"
		},
		{
			"name": "Spinach",
			"food_group": "GLV",
			"energy": "26.00",
			"protein": "2.00",
			"fat": "0.70",
			"iron": "1.14",
			"calcium": "73.00",
			"vitA": "5580.00",
			"vitC": "28.00",
			"thiamine": "0.03",
			"riboflavin": "0.25"
		},
		{
			"name": "Bottle Guard",
			"food_group": "Other Vegetables",
			"energy": "12.00",
			"protein": "0.20",
			"fat": "0.10",
			"iron": "0.46",
			"calcium": "20.00",
			"vitA": "0.00",
			"vitC": "0.00",
			"thiamine": "0.03",
			"riboflavin": "0.01"
		},
		{
			"name": "Brinjal",
			"food_group": "Other Vegetables",
			"energy": "24.00",
			"protein": "1.40",
			"fat": "0.30",
			"iron": "0.38",
			"calcium": "18.00",
			"vitA": "74.00",
			"vitC": "12.00",
			"thiamine": "0.04",
			"riboflavin": "0.11"
		},
		{
			"name": "Cauliflower",
			"food_group": "Other Vegetables",
			"energy": "30.00",
			"protein": "2.60",
			"fat": "0.40",
			"iron": "1.23",
			"calcium": "33.00",
			"vitA": "30.00",
			"vitC": "56.00",
			"thiamine": "0.04",
			"riboflavin": "0.10"
		},
		{
			"name": "Cucumber",
			"food_group": "Other Vegetables",
			"energy": "13.00",
			"protein": "0.40",
			"fat": "0.10",
			"iron": "0.60",
			"calcium": "10.00",
			"vitA": "0.00",
			"vitC": "7.00",
			"thiamine": "0.03",
			"riboflavin": "0.00"
		},
		{
			"name": "Ladies Finger",
			"food_group": "Other Vegetables",
			"energy": "35.00",
			"protein": "1.90",
			"fat": "0.20",
			"iron": "0.35",
			"calcium": "66.00",
			"vitA": "52.00",
			"vitC": "13.00",
			"thiamine": "0.07",
			"riboflavin": "0.10"
		},
		{
			"name": "Papaya (green)",
			"food_group": "Other Vegetables",
			"energy": "27.00",
			"protein": "0.70",
			"fat": "0.20",
			"iron": "0.90",
			"calcium": "28.00",
			"vitA": "0.00",
			"vitC": "12.00",
			"thiamine": "0.00",
			"riboflavin": "0.00"
		},
		{
			"name": "Parwar",
			"food_group": "Other Vegetables",
			"energy": "20.00",
			"protein": "2.00",
			"fat": "0.30",
			"iron": "1.70",
			"calcium": "30.00",
			"vitA": "153.00",
			"vitC": "29.00",
			"thiamine": "0.50",
			"riboflavin": "0.60"
		},
		{
			"name": "Pumpkin",
			"food_group": "Other Vegetables",
			"energy": "25.00",
			"protein": "1.40",
			"fat": "0.10",
			"iron": "0.44",
			"calcium": "10.00",
			"vitA": "50.00",
			"vitC": "2.00",
			"thiamine": "0.60",
			"riboflavin": "0.40"
		},
		{
			"name": "Plantain",
			"food_group": "Other Vegetables",
			"energy": "64.00",
			"protein": "1.40",
			"fat": "0.20",
			"iron": "6.27",
			"calcium": "10.00",
			"vitA": "30.00",
			"vitC": "24.00",
			"thiamine": "0.05",
			"riboflavin": "0.02"
		},
		{
			"name": "Carrot",
			"food_group": "Roots & Tubers",
			"energy": "48.00",
			"protein": "0.90",
			"fat": "0.20",
			"iron": "1.03",
			"calcium": "80.00",
			"vitA": "1890.00",
			"vitC": "3.00",
			"thiamine": "0.04",
			"riboflavin": "0.02"
		},
		{
			"name": "Onion",
			"food_group": "Roots & Tubers",
			"energy": "50.00",
			"protein": "1.20",
			"fat": "0.10",
			"iron": "0.60",
			"calcium": "47.00",
			"vitA": "0.00",
			"vitC": "11.00",
			"thiamine": "0.06",
			"riboflavin": "0.01"
		},
		{
			"name": "Potato",
			"food_group": "Roots & Tubers",
			"energy": "97.00",
			"protein": "1.60",
			"fat": "0.10",
			"iron": "0.48",
			"calcium": "10.00",
			"vitA": "24.00",
			"vitC": "17.00",
			"thiamine": "0.10",
			"riboflavin": "0.01"
		},
		{
			"name": "Radish",
			"food_group": "Roots & Tubers",
			"energy": "32.00",
			"protein": "0.60",
			"fat": "0.30",
			"iron": "0.37",
			"calcium": "50.00",
			"vitA": "3.00",
			"vitC": "17.00",
			"thiamine": "0.06",
			"riboflavin": "0.02"
		},
		{
			"name": "Amla",
			"food_group": "Fruits",
			"energy": "58.00",
			"protein": "0.50",
			"fat": "0.10",
			"iron": "1.20",
			"calcium": "50.00",
			"vitA": "9.00",
			"vitC": "600.00",
			"thiamine": "0.03",
			"riboflavin": "0.01"
		},
		{
			"name": "Apple",
			"food_group": "Fruits",
			"energy": "59.00",
			"protein": "0.20",
			"fat": "0.66",
			"iron": "1.00",
			"calcium": "10.00",
			"vitA": "0.00",
			"vitC": "1.00",
			"thiamine": "0.00",
			"riboflavin": "0.00"
		},
		{
			"name": "Banana",
			"food_group": "Fruits",
			"energy": "116.00",
			"protein": "1.20",
			"fat": "0.36",
			"iron": "0.90",
			"calcium": "17.00",
			"vitA": "78.00",
			"vitC": "7.00",
			"thiamine": "0.05",
			"riboflavin": "0.08"
		},
		{
			"name": "Grape",
			"food_group": "Fruits",
			"energy": "71.00",
			"protein": "0.50",
			"fat": "0.30",
			"iron": "0.50",
			"calcium": "20.00",
			"vitA": "0.00",
			"vitC": "1.00",
			"thiamine": "0.00",
			"riboflavin": "0.00"
		},
		{
			"name": "Lemon",
			"food_group": "Fruits",
			"energy": "57.00",
			"protein": "1.00",
			"fat": "0.90",
			"iron": "0.26",
			"calcium": "70.00",
			"vitA": "0.00",
			"vitC": "39.00",
			"thiamine": "0.02",
			"riboflavin": "0.01"
		},
		{
			"name": "Guava",
			"food_group": "Fruits",
			"energy": "51.00",
			"protein": "0.90",
			"fat": "0.30",
			"iron": "0.27",
			"calcium": "10.00",
			"vitA": "0.00",
			"vitC": "212.00",
			"thiamine": "0.03",
			"riboflavin": "0.03"
		},
		{
			"name": "Mango",
			"food_group": "Fruits",
			"energy": "74.00",
			"protein": "0.60",
			"fat": "0.40",
			"iron": "1.30",
			"calcium": "14.00",
			"vitA": "2743.00",
			"vitC": "16.00",
			"thiamine": "0.06",
			"riboflavin": "0.09"
		},
		{
			"name": "Orange",
			"food_group": "Fruits",
			"energy": "48.00",
			"protein": "0.70",
			"fat": "0.20",
			"iron": "0.32",
			"calcium": "26.00",
			"vitA": "1104.00",
			"vitC": "30.00",
			"thiamine": "0.00",
			"riboflavin": "0.00"
		},
		{
			"name": "Papaya (ripe)",
			"food_group": "Fruits",
			"energy": "32.00",
			"protein": "0.60",
			"fat": "0.10",
			"iron": "0.50",
			"calcium": "17.00",
			"vitA": "666.00",
			"vitC": "57.00",
			"thiamine": "0.04",
			"riboflavin": "0.25"
		},
		{
			"name": "Tomato",
			"food_group": "Fruits",
			"energy": "20.00",
			"protein": "0.90",
			"fat": "0.20",
			"iron": "0.64",
			"calcium": "48.00",
			"vitA": "351.00",
			"vitC": "27.00",
			"thiamine": "0.12",
			"riboflavin": "0.06"
		},
		{
			"name": "Milk (cow)",
			"food_group": "Milk & Products",
			"energy": "67.00",
			"protein": "3.20",
			"fat": "4.10",
			"iron": "0.20",
			"calcium": "120.00",
			"vitA": "53.00",
			"vitC": "2.00",
			"thiamine": "0.05",
			"riboflavin": "0.19"
		},
		{
			"name": "Milk (human)",
			"food_group": "Milk & Products",
			"energy": "65.00",
			"protein": "1.10",
			"fat": "3.40",
			"iron": "0.00",
			"calcium": "28.00",
			"vitA": "41.00",
			"vitC": "3.00",
			"thiamine": "0.02",
			"riboflavin": "0.02"
		},
		{
			"name": "Egg",
			"food_group": "Flesh Foods",
			"energy": "173.00",
			"protein": "13.30",
			"fat": "13.30",
			"iron": "2.10",
			"calcium": "60.00",
			"vitA": "420.00",
			"vitC": "0.00",
			"thiamine": "0.10",
			"riboflavin": "0.40"
		},
		{
			"name": "Fish (rohu)",
			"food_group": "Flesh Foods",
			"energy": "92.00",
			"protein": "16.60",
			"fat": "1.40",
			"iron": "1.00",
			"calcium": "650.00",
			"vitA": "0.00",
			"vitC": "22.00",
			"thiamine": "0.05",
			"riboflavin": "0.07"
		},
		{
			"name": "Chillies",
			"food_group": "Spices",
			"energy": "29.00",
			"protein": "2.90",
			"fat": "0.60",
			"iron": "4.40",
			"calcium": "30.00",
			"vitA": "175.00",
			"vitC": "111.00",
			"thiamine": "0.19",
			"riboflavin": "0.39"
		},
		{
			"name": "Oil",
			"food_group": "Fats & Oils",
			"energy": "900.00",
			"protein": "0.00",
			"fat": "100.00",
			"iron": "0.00",
			"calcium": "0.00",
			"vitA": "0.00",
			"vitC": "0.00",
			"thiamine": "0.00",
			"riboflavin": "0.00"
		},
		{
			"name": "Sugar",
			"food_group": "Sugar & Jaggery",
			"energy": "398.00",
			"protein": "0.10",
			"fat": "0.00",
			"iron": "0.16",
			"calcium": "12.00",
			"vitA": "0.00",
			"vitC": "0.00",
			"thiamine": "0.00",
			"riboflavin": "0.00"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = 68
// module chunks = 0